'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _checkinDataActions = require('actions/checkinDataActions');

// checkinUrls are stored by customer id
function checkinUrls() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    switch (action.type) {
        case _checkinDataActions.CHECKIN_DATA_RECEIVED:
            return action.checkinData;
        default:
            return state;
    }
}

exports.default = checkinUrls;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/reducers/checkinUrls.js
// module id = 1395
// module chunks = 0